<template>
   <v-app id="login">
      <v-content>
         <v-container fill-height fluid>
            <v-layout align-center justify-center>
               <v-flex lg4 md4 sm8 xs12>
                  <v-scale-transition origin="center center 0">
                     <v-card class="pa-4 clear-bg" v-show="init" style="border-radius: 10px">
                        <v-card-text>
                           <div class="layout column align-center">
                              <v-img :src="brandLogo" contain height="75"
                                     width="300"></v-img>
                              <span class="subheading mb-4" style="font-size: 14px !important;"></span>
                           </div>
                           <v-form autocomplete="none">
                              <v-text-field v-if="brandId == 2" @keyup.native.enter="onLoginClick" append-icon="store"
                                            flat floating label="Empresa / Correspondente" solo-inverted type="text"
                                            v-model="formData.brandCode"></v-text-field>
                              <v-text-field @keyup.native.enter="onLoginClick" append-icon="person"
                                            flat floating label="Usuário" solo-inverted
                                            type="text" v-model="formData.loginName"></v-text-field>
                              <v-text-field @keyup.native.enter="onLoginClick" append-icon="lock" browser-autocomplete="nope"
                                            flat label="Senha" solo-inverted
                                            type="password" v-model="formData.password"></v-text-field>
                           </v-form>
                        </v-card-text>
                        <v-card-actions>
                           <v-btn color="#4C48FF" flat v-on:click="forgotPasswordModal = true">Esqueceu a Senha?</v-btn>
                           <v-spacer></v-spacer>
                           <v-btn :loading="loading" @click="onLoginClick" style="color: white;" color="#4C48FF" round>Acessar</v-btn>
                        </v-card-actions>
                     </v-card>
                  </v-scale-transition>
               </v-flex>
            </v-layout>
         </v-container>
      </v-content>
       <v-dialog v-model="forgotPasswordModal" width="350">
         <v-card class="forgot-password-card">
            <div style="font-size: 20px; padding: 20px;">
               Gerar nova senha temporária
            </div>

            <div style="padding: 0 20px;">
               <a-text-field label="Email" v-model="forgotPasswordData.email"></a-text-field>
               <a-text-field label="CPF/CNPJ" v-mask="['###.###.###-##', '##.###.###/####.##']" v-model="forgotPasswordData.federalId"></a-text-field>
            </div>

            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="blue darken-1" flat v-on:click="closeForgotPasswordModal()">
                  Fechar
               </v-btn>
               <v-btn color="blue darken-1" flat v-on:click="forgotPassword()">
                  Enviar
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
      <div v-if="brandLoading" class="fullscreen-loading">
         <v-progress-circular color="#4C48FF" indeterminate="indeterminate"></v-progress-circular>
         <p>Carregando...</p>
      </div>
   </v-app>
</template>

<script>
   export default {
      data: () => ({
         init: false,
         loading: false,
         forgotPasswordModal: false,

         brandId: null,
         brandName: '',
         brandLogo: '',
         brandLoading: false,

         formData: {
            brandCode: '',
            loginName: '',
            password: ''
         },

         forgotPasswordData: {
            email: '',
            federalId: '',
         }
      }),

      methods: {
         async getBrand() {
            this.brandLoading = true;

            await this.$api.dataService.getPublicData('getBrandSimple', {})
               .then((res) => {
                  this.brandId = res.brandId;
                  this.brandName = res.brandName;
                  this.brandLogo = res.brandLogo;

                  document.title = this.brandName;
               }).catch((err) => {
                  //
               });

            this.brandLoading = false;
         },

         closeForgotPasswordModal() {
            this.forgotPasswordModal = false;
            this.forgotPasswordData.email = '';
            this.forgotPasswordData.federalId = '';
         },

         forgotPassword() {
            this.$api.authService.forgotPasswordAdmin({ mainEmail: this.forgotPasswordData.email.toLowerCase().trim(), federalId: this.forgotPasswordData.federalId.replace(/\D/g, '').trim() }).then(() => {
               this.closeForgotPasswordModal();
               this.$notifyUser({
                  message: 'Email enviado com sucesso!',
                  type: 'success'
               });
            }).catch((err) => {
               console.log(err);
               this.$notifyUser({
                  type: 'error',
                  message: err ? err.msg : "Ocorreu um erro ao enviar o email!"
               });
            });
         },

         onLoginClick () {
            this.loading = true;

            this.$store.dispatch('company/stSaveBrandCode', this.formData.brandCode);

            if (!this.formData.loginName || !this.formData.password || (this.brandId == 2 && !this.formData.brandCode)) {
               this.loading = false;
               this.$notifyUser({
                  message: `Favor informar os ${this.brandId == 2 ? '3' : '2'} campos.`,
                  type: 'error'
               });
               return;
            }

            this.formData.brandCode = this.formData.brandCode ? this.formData.brandCode.trim() : null;
            this.formData.loginName = this.formData.loginName.trim();
            this.formData.password = this.formData.password.trim();

            this.$api.authService.login(this.formData)
               .then(() => this.init = false)
               .finally(() => this.loading = false);

         }
      },

      created() {
         this.getBrand();
      },

      mounted () {
         setTimeout(() => this.init = true, 100);
         this.formData.brandCode = this.$store.state.company.brandCode;
      }

   };
</script>
<style lang="css" scoped>
   #login, .forgot-password-card {
      background-color: #EFEFEF;
   }

   .clear-bg {
      color: #EFEFEF !important;
      box-shadow: 0 2px 20px 0 rgba(0,0,0,0.1);
      /* background-color: rgba(0, 0, 0, .7) !important; */
   }

   .fullscreen-loading {
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #EFEFEF;
      z-index: 2000;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
   }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue